module.exports = __webpack_public_path__ + "img/montreal-city-bus-wifi.c2eb6181.jpg";